import { isAxiosError } from "axios";
import axios from "../api";
/** The stored solution, else the market-only solve; null when neither exists. */
export const getGallerySolution = async (setId) => {
    try {
        const res = await axios.get(`/gallery/solutions/${setId}`);
        return res.data;
    }
    catch (error) {
        if (isAxiosError(error) && error.response?.status === 404)
            return null;
        throw error;
    }
};
//# sourceMappingURL=gallerySolution.js.map